import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BankComponent } from './components/bank/bank.component';
import { WithdrawalsComponent } from './components/withdrawals/withdrawals.component';
import { CashOutComponent } from './components/cash-out/cash-out.component';
import { PermissionsGuardService } from '../../../shared/services/permissions-guard.service';
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';
import { AddCashOutWalletRequestComponent } from './components/cash-out/add-cash-out-wallet-request/add-cash-out-wallet-request.component';
import { MatInputModule } from '@angular/material/input';

const financialsRoutes: Routes = [
  {
    path: 'bank',
    component: BankComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  {
    path: 'balance',
    component: WithdrawalsComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  { path: 'cash-out', component: CashOutComponent },
];

@NgModule({
  declarations: [
    BankComponent,
    WithdrawalsComponent,
    CashOutComponent,
    AddCashOutWalletRequestComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(financialsRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule
  ]
})
export class FinancialsModule { }
